import {LOADER_SET, SESSION_SET} from './actions';
import { AnyAction } from 'redux';

export const loader = (state: boolean = false, action: AnyAction): boolean => {
  switch (action.type) {
    case LOADER_SET:
      return action.data;

    default:
      return state;
  }
};

export const session = (state: string = '', action: AnyAction): string => {
  switch (action.type) {
    case SESSION_SET:
      return action.data;

    default:
      return state;
  }
};
